/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { string } from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReactHTMLParser from 'react-html-parser';

const useStyles = makeStyles((theme) => ({
    productName: {
        fontWeight: '400',
    },
    productListingName: {
        fontWeight: 'bold',
        fontSize: '1em',
        letterSpacing: '.4px',
        fontFamily: theme?.typography?.fontFamily,
        color: theme.palette.product?.name || theme.palette.colorPrimary,
        webkitFontSmoothing: 'antialiased',
    },
    productNameLength: {
        margin: 0,
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        whiteSpace: 'normal',
    },
}));

const ProductName = ({ name }) => {
    const classes = useStyles();
    const productNameStyle = classes.productName;

    return (
        <Typography className={productNameStyle}>
            <span className={`${productNameStyle} transformedName`}>
                {ReactHTMLParser(name)}
            </span>
        </Typography>
    );
};

ProductName.propTypes = {
    name: string.isRequired,
};

export default ProductName;
